export class CustomerModel {
  ShipTo: number | null;
  Name: string;
  SurchargeType: string;
  IncludeInNewSurchargeEvents: boolean;
  PrimarySalesRep: string;
  Formula: string;
  Plant: string;
  Region: string;
  ProductType: string;
  Frequency: string;
  Currency: string;
  Multiplier: number;
  Update: string;
  // this filed used only for UI filter purpose
  UpdateEx: string;
  SalesOrg: string;
  SAPMaterialProductCode: string;
  SAPEnergySurchargeCode: string;
  Unit: number | null;
  Uom: string;
  Determinants: string;
  SurchargeStartDate: Date | null;
  Create: boolean;
  SendEmail: boolean;
  LatestNoteText: string;
  DeterminantsProps: { [key: string]: any };
  UpdatedBy: string;
  UpdatedAt: Date | null;

  constructor() {
    this.ShipTo = null;
    this.Name = "";
    this.SurchargeType = "";
    this.IncludeInNewSurchargeEvents = false;
    this.PrimarySalesRep = "";
    this.Formula = "";
    this.Plant = "";
    this.Region = "";
    this.ProductType = "";
    this.Frequency = "";
    this.Currency = "";
    this.Multiplier = 0;
    this.Update = "";
    this.UpdateEx = "";
    this.SalesOrg = "";
    this.SAPMaterialProductCode = "";
    this.SAPEnergySurchargeCode = "";
    this.Unit = null;
    this.Uom = "";
    this.Determinants = "";
    this.SurchargeStartDate = new Date();
    this.Create = false;
    this.SendEmail = false;
    this.LatestNoteText = "";
    this.DeterminantsProps = {
      "Base Milage": { IsNumeric: true, NumericValue: 0 },
      "Base NG": { IsNumeric: true, NumericValue: 0 },
      Diesel: { IsNumeric: true, NumericValue: 0 },
      DieselRecovery: { IsNumeric: true, NumericValue: 0 },
      "NG Efficiency": { IsNumeric: true, NumericValue: 0 },
      "NOLA Tax": { IsNumeric: false, StringValue: "" },
      SpecPower: { IsNumeric: true, NumericValue: 0 },
    };
    this.UpdatedAt = new Date();
    this.UpdatedBy = "";
  }
}

// Define your formula type
export interface Formula {
  EffectiveFrom: string;
  EffectiveTo: string;
  isEffective?: boolean;
  [key: string]: any; // other optional props
}
